
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";
import Checkbox from "@/components/shared/Checkbox.vue";
import styleUtils from '@/utils/style';
import GenericPanel from "../shared/GenericPanel.vue";
import GenericSubPanel from "../shared/GenericSubPanel.vue";
import GenericButton from "../shared/GenericButton.vue";

export default defineComponent({
  name: "Skills",
  components: {
    Checkbox,
    GenericPanel,
    GenericSubPanel,
    GenericButton,
},
  setup() {
    const store = useStore();
    const taggedSkills = computed(() => store.state.build.info.taggedSkills)
    const successClass = computed(() => styleUtils.calculateSuccessClass(taggedSkills.value, 4));
    const showInfo = (category: string, stat: string) => {
      store.dispatch('handleIncomingCommand', {
        command: 'updateInfoPanel',
        data: { category, stat }
      });
    };
    const tagSkill = (skill: string) => {
      store.dispatch('handleIncomingCommand', {
        command: 'tagSkill',
        data: skill
      });
    }
    const getSkillData = (skill: string) => {
      const data = {
        value: store.state.build.Skills[skill].value,
        tagged: store.state.build.Skills[skill].tagged,
      };
      return data;
    };
    return {
      state: store.state,
      Skills: store.state.build.Skills,
      taggedSkills,
      showInfo,
      tagSkill,
      getSkillData,
      successClass
    };
  },
});
